import {
  mapState
} from "vuex";


import FileLink from '@/components/FileLink'
export default {
  components: {
    FileLink,
  },
  computed: {
    ...mapState({
      
    })
  },
  data() {
    return {
      
    }
  },
  methods: {
    // 显示关联项目列表弹窗
    showProjectList(){
      this.projectListStatus = true
    },
    // 关闭关联项目列表弹窗
    hideProjectList(){
      this.projectListStatus = false
    },
    // 显示会议纪要
    showMeetingSumary(id){
      this.meetingSumaryId = id
      this.addMeetingStatus = true
    },
    // 隐藏会议纪要弹窗
    hideMeetingSumary(){
      this.addMeetingStatus = false
      this.projectListStatus = false
      this.meetingSumaryId = ""
      
      this.getLists()
    },

    // 显示会议详情
    showMeetingInfo(id){
      this.meetingId = id
      this.meetingInfoStatus = true
    },
    // 隐藏会议详情
    hideMeetingInfo(){
      this.meetingInfoStatus = false
      this.meetingId = ""
    },
    // 参会人员
    getUserList(users, type) {
      if (!users) {
        return
      }
      let _item = ""
      let max = 3
      let _length
      if (!type) {
        _length = users.length > max ? max : users.length
      } else {
        _length = users.length
      }

      for (var i = 0; i < _length; i++) {
        _item += '<span class="user-item">' + users[i].name + '</span>'
      }
      return _item
    },
    
  },
  watch: {
    
  }
}


// WEBPACK FOOTER //
// ./src/Mixins/meetingMixin.js